(function () {
  "use strict";

  const MOBILE_QUERY = window.matchMedia("(max-width: 749px)");
  const DRAWER_SELECTOR = ".drawer--cart";
  const TOTAL_SELECTOR = "[data-cart-total]";

  function formatDrawerTotal() {
    if (!MOBILE_QUERY.matches) return;

    const drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;

    const total = drawer.querySelector(TOTAL_SELECTOR);
    if (!total) return;

    const subtotal = parseInt(total.getAttribute("data-cart-total"), 10);
    if (Number.isNaN(subtotal)) return;

    total.textContent =
      subtotal === 0
        ? window.theme.strings.free
        : window.theme.formatMoney(subtotal, window.theme.moneyFormat);

    const note = drawer.querySelector("[data-cart-installment-note]");
    if (!note || !window.theme.formatMoney) return;

    const months =
      parseInt(note.getAttribute("data-installment-months"), 10) || 6;
    const template =
      note.getAttribute("data-installment-template") ||
      "4 interest-free installments, or from [amount]/mo";
    const monthly = Math.round(subtotal / months);
    const amount = window.theme.formatMoney(monthly, window.theme.moneyFormat);
    note.textContent = template.replace("[amount]", amount);
  }

  function init() {
    formatDrawerTotal();

    document.addEventListener("theme:product:added", formatDrawerTotal);
    MOBILE_QUERY.addEventListener("change", formatDrawerTotal);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", formatDrawerTotal);
})();
